import { NgIf, UpperCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ScreenSizes } from 'src/app/classes/screen-sizes.class';
import { capitalize } from 'src/app/lib/capitalize';
import { DialogService } from 'src/app/services/dialog.service';
import { PermissionService } from 'src/app/services/permission.service';
import { PricingService } from 'src/app/services/pricing.service';
import { StateService } from 'src/app/services/state.service';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { CapitalizePipe } from '../../../shared/pipes/capitalize.pipe';

@Component({
  selector: 'app-pro-tag',
  templateUrl: './pro-tag.component.html',
  styleUrls: ['./pro-tag.component.scss'],
  standalone: true,
  imports: [NgIf, RouterLink, TooltipDirective, SvgComponent, UpperCasePipe, CapitalizePipe],
})
export class ProTagComponent implements OnInit {
  text: string;
  @Input() center: boolean;
  @Input() tenantId: string;
  @Input() permission: string;
  @Input() noTop: boolean;
  @Input() small: boolean = ScreenSizes.screenSize() === 'mobile';
  allowPricingLink: boolean;
  productName: string;
  canStartTrial: boolean;

  constructor(
    public state: StateService,
    private dialog: DialogService,
    private permissionService: PermissionService,
    private pricingService: PricingService
  ) {}

  ngOnInit() {
    if (!this.state.plan) return;
    this.canStartTrial = this.state.plan.trialEnd && this.state.plan.product.isFree;
    this.allowPricingLink = this.permissionService.shouldRedirectToPricingPage(this.tenantId);
    if (this.permission) this.productName = this.permissionService.getMinPlanForPermission(this.permission);
    if (!this.productName) this.productName = 'pro';

    const trialLength = this.pricingService.getTrialLengthDays();

    if (this.canStartTrial && trialLength) {
      this.text = 'Start your free trial!';
    } else {
      this.text = `Upgrade to Picflow ${capitalize(this.productName)}!`;
    }
  }

  closeDialogs() {
    this.dialog.close();
  }
}
